import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import purchaseReportService from '../../../../services/purchaseReportService';
import PriceTrackingDashboard from '../PriceTrackingDashboard';
import PriceTrackingShell from './PriceTrackingShell';
import usePriceTrackingFilters from './usePriceTrackingFilters';

export default function PriceTrackingDashboardPage() {
  const { filters, updateFilter, buildParams, suppliers, products } = usePriceTrackingFilters();
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [dashboardMeta, setDashboardMeta] = useState(null);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await purchaseReportService.getPriceTrackingDashboard(buildParams());
      if (res.success) {
        setDashboardData(res.data);
        setDashboardMeta(res.meta);
        if (res.meta?.warning) {
          setToast({ isOpen: true, message: res.meta.warning, type: 'warning' });
        }
      } else {
        setToast({ isOpen: true, message: res.message || 'Error al cargar', type: 'error' });
      }
    } catch (error) {
      setToast({
        isOpen: true,
        message: error.response?.data?.message || 'Error al cargar el dashboard',
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  }, [buildParams]);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const empty = dashboardData && dashboardData.kpis?.purchase_lines === 0;

  return (
    <PriceTrackingShell
      title="Dashboard de precios"
      subtitle="Gráficos de gasto, proveedores clave y evolución de precios por insumo."
      filters={filters}
      updateFilter={updateFilter}
      suppliers={suppliers}
      products={products}
      onQuery={loadData}
      loading={loading}
      toast={toast}
      onToastClose={() => setToast({ ...toast, isOpen: false })}
    >
      {loading && !dashboardData ? (
        <div className="bg-white rounded-lg shadow-md p-12 text-center text-gray-500">Cargando...</div>
      ) : empty ? (
        <div className="bg-white rounded-lg shadow-md p-10 text-center">
          <p className="text-gray-600 mb-2">No hay compras en el período con los filtros actuales.</p>
          {filters.insumosOnly && (
            <p className="text-sm text-amber-700 mb-4">
              Si activaste &quot;Solo insumos&quot;, marca productos como insumo en el catálogo o desactiva ese filtro.
            </p>
          )}
          <p className="text-sm text-gray-500">Amplía el rango de fechas o consulta el <Link to="/compras/reports/price-tracking/history" className="text-teal-600 hover:underline">historial</Link>.</p>
        </div>
      ) : (
        <PriceTrackingDashboard data={dashboardData} meta={dashboardMeta} />
      )}
    </PriceTrackingShell>
  );
}
